'use strict';

import { CoreRepository } from '../CoreRepository';
import type { UserActivityCategory } from '../../Entities/User/UserActivity';
import { UserActivity } from '../../Entities/User/UserActivity';

export class UserActivityRepository extends CoreRepository {
  public addUserActivity(userId: number, payload: object = {}) {
    return this.webAPI.addUserActivity(userId, payload).then((response) => {
      const item = new UserActivity();
      item.hydrate(response);

      return item;
    });
  }

  public getUserActivitiesCategories(userId: number) {
    return this.webAPI.getUserActivitiesCategories(userId).then((response) => {
      const collection: UserActivityCategory[] = [];

      response.forEach((userActivityCategory: UserActivityCategory) => {
        collection.push(userActivityCategory);
      });

      return collection;
    });
  }
}
